// style
import './style/menu.css'
// route
import { NavLink, useLocation } from "react-router-dom";
// component
import MenuItems from "../../../../components/basement/admin/menu/menuItems.tsx";
import React from 'react';
// axios
import axios from 'axios';
// @ts-ignore
import Cookies from "js-cookie";
// routes
import { routes } from '../../../../features/routes/route.tsx';

const Menu = (props) => {
    const location = useLocation();
    const currentPath = decodeURIComponent(location.pathname);
    const logOut = () => {
        let role: string = '';
        let token = Cookies.get('agent_token');
        let admin = Cookies.get('admin_token')
        let photoToken = Cookies.get('photographer_token');
        let key = process.env.REACT_APP_API_CLIENT_KEY;
        let token_axios: string = '';
        if (token) {
            role = 'agent';
            token_axios = token;
        }
        else if (photoToken) {
            role = 'photographer';
            token_axios = photoToken;
        }
        else {
            role = 'admin';
            token_axios = admin;
            key = process.env.REACT_APP_API_ADMIN_KEY;
        }
        var config: any = {
            method: 'post',
            url: `${routes.api[0].address}/${role}/logout`,
            headers: {
                'Accept': 'application/json',
                'APIKEY': `${key}`,
                'Authorization': `Bearer ${token_axios}`
            }
        };
        axios(config)
            .then(function () {
                if (token) {
                    Cookies.remove('agent_token')
                }
                else if (photoToken) {
                    Cookies.remove('photographer_token')
                }
                else {
                    Cookies.remove('admin_token')
                }
                window.open('/', '_self');
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    return (
        <>
            <section id="menu-admin">
                {/* start dashboard */}
                <div id="dashboard-menu">
                    <div className="container py-4">
                        {/* header buttons */}
                        <div className="btn-place">
                            <div className="btn-place-body rounded rounded-3 p-3">
                                <ul className="list-group pt-2 p-0">
                                    <li className="list-group-item p-0">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <NavLink to="/">
                                            <div className="d-flex">
                                                <svg width="24" height="24" className="ms-2 vertical-td" viewBox="0 0 24 24"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9.02 2.83992L3.63 7.03992C2.73 7.73992 2 9.22992 2 10.3599V17.7699C2 20.0899 3.89 21.9899 6.21 21.9899H17.79C20.11 21.9899 22 20.0899 22 17.7799V10.4999C22 9.28992 21.19 7.73992 20.2 7.04992L14.02 2.71992C12.62 1.73992 10.37 1.78992 9.02 2.83992Z"
                                                        stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                    <path d="M12 17.99V14.99" stroke="#6E6E6E" strokeWidth="1.5"
                                                        strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <p className="text-6e vertical-td mt-1 ms-1">خانه</p>
                                            </div>
                                        </NavLink>
                                    </li>
                                    <li className="list-group-item p-0">
                                        <NavLink to="#" onClick={() => logOut()}>
                                            <div className="d-flex">
                                                <svg width="24" height="24" className="ms-2 vertical-td mt-1"
                                                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.87988 18.1501V16.0801" stroke="#6E6E6E"
                                                        strokeWidth="1.5" strokeLinecap="round" />
                                                    <path d="M12 18.15V14.01" stroke="#6E6E6E" strokeWidth="1.5"
                                                        strokeLinecap="round" />
                                                    <path d="M17.1201 18.1499V11.9299" stroke="#6E6E6E"
                                                        strokeWidth="1.5" strokeLinecap="round" />
                                                    <path
                                                        d="M17.1199 5.8501L16.6599 6.3901C14.1099 9.3701 10.6899 11.4801 6.87988 12.4301"
                                                        stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round" />
                                                    <path d="M14.1899 5.8501H17.1199V8.7701" stroke="#6E6E6E"
                                                        strokeWidth="1.5" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                    <path
                                                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                        stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                                <p className="text-6e mt-1 ms-1">خروج از حساب</p>
                                            </div>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* end header buttons */}
                        {/* dashboard content */}
                        <div className="dashboard-content">
                            {/* route items */}
                            <div className="admin-menu-content">
                                <div className="content container" dir="rtl">
                                    {props.routes?.map((item: any, index: number) => (
                                        <div key={item.icon}>
                                            <MenuItems item={item} index={index} currentPath={currentPath} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/*  end dashboard content  */}
                    </div>
                </div>
                {/* end dashboard */}
            </section>
        </>
    )
}

export default Menu;